{
  "ResourcePortalBookingSidebar": {
    "booking": "Rezerwacja",
    "dates": "Daty",
    "tasks": "Zadania",
    "note": "Notatka",
    "noNoteLeft": "Brak notatki",
    "files": "Pliki",
    "comingSoon": "Wkrótce"
  },
  "ResourcePortalMenu": {
    "portalFor": "portal dla",
    "routes": {
      "calendar": "Kalendarz",
      "bookings": "Rezerwacje",
      "details": "Szczegóły"
    }
  },
  "CalendarRoute": {
    "anErrorOccurred": "Wystąpił błąd",
    "leaveWithoutSubmittingChanges": "Czy na pewno chcesz opuścić stronę bez zapisania zmian?",
    "shareAvailability": "{{resourceFullName}}, podziel się swoją dostępnością z {{companyUserFirstName}} w firmie {{companyName}}",
    "successShareTitle": "Dostępności wysłane",
    "successShare": "{{companyUserFirstName}} z {{companyName}} zostanie powiadomiony o Twojej nadchodzącej dostępności",
    "gotItThanks": "Dzięki, zrozumiałem",
    "availabilityBetween": "{{companyUserFirstName}} chce znać Twoją dostępność między {{startDate}} a {{endDate}}.",
    "shareInstruction": "Udostępnij swoją dostępność, wybierając statusy poniżej, aby wypełnić kalendarz.",
    "submitCalendar": "Wyślij kalendarz",
    "deleteAvailability": "Usuń dostępność",
    "today": "Dzisiaj",
    "allDay": "Cały dzień",
    "perDay": "Dostępny przez {{hours}}h{{mins}} / dzień",
    "daily": " codziennie",
    "unavailable": "Niedostępny",
    "availabilityAssignedCannotEdit": "Ta dostępność ma przypisane produkcje i nie może być edytowana",
    "mobileHint": {
      "title": "Dodaj dostępność",
      "intro": "Użyj kalendarza, aby zarządzać okresami dostępności:",
      "items": {
        "selectStatus": "Wybierz Dostępny albo Niedostępny, a potem przytrzymaj i przeciągnij po datach, aby dodać okres.",
        "adjustHours": "Stuknij dodany okres, aby ustawić cały dzień, godziny dziennie albo konkretny przedział czasowy.",
        "moveOrResize": "Przeciągnij istniejący okres, aby go przesunąć, albo przeciągnij jego krawędź, aby wydłużyć lub skrócić zakres dat."
      },
      "open": "Pokaż pomoc dotyczącą dostępności",
      "dismiss": "Rozumiem"
    },
    "status": {
      "AVAILABLE": "Dostępny",
      "UNAVAILABLE": "Niedostępny"
    },
    "tooltip": {
      "actionView": "KLIKNIJ, ABY ZOBACZYĆ",
      "actionEdit": "KLIKNIJ, ABY EDYTOWAĆ",
      "cannotEdit": "Nie można edytować",
      "notEditable": "NIE EDYTOWALNE",
      "availableAllDay": "Dostępny przez cały dzień",
      "availableForHours": "Dostępny przez {{hours}} godzin dziennie",
      "availableSpecificHours": "Dostępny od {{start}} do {{end}} codziennie",
      "deleteAvailability": "Usuń dostępność"
    },
    "cannotEditModal": {
      "title": "Nie można edytować statusu",
      "message": "Tylko właściciel rezerwacji może edytować ten status. Jeśli potrzebujesz zmiany tego statusu, skontaktuj się z osobą koordynującą Twoją rezerwację.",
      "dismiss": "Zamknij"
    },
    "availabilityEditDialog": {
      "title": "Konfiguruj dostępność",
      "description": "Edytowanie dostępności dla",
      "saveChanges": "Zapisz zmiany"
    }
  },
  "BookingsRoute": {
    "comingSoon": "Już wkrótce",
    "description": "Zobacz swoje aktywne i poprzednie rezerwacje w {{companyName}}",
    "details": "Śledź potwierdzone rezerwacje i monitoruj statusy związane z fakturami i płatnościami."
  },
  "ContactDetailsRoute": {
    "comingSoon": "Wkrótce",
    "description": "Poinformuj {{companyName}}, gdy Twoje dane kontaktowe ulegną zmianie",
    "details": "Prześlij nowe informacje kontaktowe i wykonaj inne przydatne akcje za pośrednictwem tego portalu."
  }
}
